import { Component, Input, HostBinding } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'ng-casto-circle-btn',
  templateUrl: './circle-btn.component.html',
})
export class CircleBtnComponent {
  @HostBinding('class.isLoading') get isLoading() {
    return this.loading;
  }
  @HostBinding('class.disabled') get isDisabled() {
    return this.disabled;
  }

  @Input() disabled: boolean;
  @Input() loading: boolean;
  @Input() label: string;

  @Input() faIcon?: IconDefinition;
  @Input() faSize?: string = 'xl';
  @Input() color: 'blue' | 'yellow' | 'light-grey' | 'grey' | 'white-blue' | 'red' = 'blue';
  constructor() {}

  disabledAreaClick(e: Event) {
    e.stopPropagation();
    e.preventDefault();
  }
}
